import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

import TextInput from '../../../Components/Inputs/TextInput';
import SweetAlert from '../../../Components/Alerts/SweetAlert';
import { ALERT_TYPE } from '../../../Components/Alerts/alert_enums';

const SocialNameFields = ({ register, errors }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      spacing={2}
      className={classes.nameFieldsContainer}
    >
      <Grid item xs={12}>
        <SweetAlert
          id="SocialLoginDialog_nameRequired"
          type={ALERT_TYPE.WARNING}
          message="Para completar tu registro necesitas ingresar tu nombre y apellidos."
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          inputRef={register}
          id="SocialLoginDialog_firstName"
          required
          fullWidth
          margin="none"
          label="Nombres"
          name="firstName"
          error={Boolean(errors.firstName)}
          helperText={errors.firstName && errors.firstName.message}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          inputRef={register}
          id="SocialLoginDialog_lastName"
          required
          fullWidth
          margin="none"
          label="Apellidos"
          name="lastName"
          error={Boolean(errors.lastName)}
          helperText={errors.lastName && errors.lastName.message}
        />
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  nameFieldsContainer: {
    marginBottom: theme.spacing(2)
  }
}));

export default SocialNameFields;
